// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--NbvrC";
export var title = "styles-module--title--YkDlM";
export var subtitle = "styles-module--subtitle--2Z2uS";
export var authors = "styles-module--authors--5SKZ5";